// In-Built
import { Injectable, NgZone } from '@angular/core';

// Material
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class PpNotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone,
  ) {}

  /**
   *
   * @param message: string
   *
   * Show Success Message
   *
   */
  public showSuccess(message: string): void {
    this.snackBar.open(message, 'close', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 2000,
    });
  }

  /**
   *
   * @param message: string
   *
   * Show Error Message
   */
  public showError(message: string): void {
    this.zone.run(() => {
      this.snackBar.open(message, 'Close', {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 5000,
      });
    });
  }
}
